<template>
  <section class="container">
    <div class="management_top_box mb-3">
      <h4>{{ $t("management.qnaClsManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.ClassificationName") }}</th>
            <td>
              <input
                type="text"
                name="className"
                v-model="qnaCls.className"
                class="int_type01"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.description") }}</th>
            <td>
              <textarea
                name="classKoDesc"
                v-model="qnaCls.classDesc"
                class="textarea_type"
                rows="10"
                v-validate="'required'"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/qna/cls"
          class="btn btn-outline-dark btn-lg"
          >{{ $t("common.list") }}</router-link
        >
        <a href="#" @click="saveQnaCls" class="btn btn-primary btn-lg">{{
          $t("common.save")
        }}</a>
      </div>
    </div>
  </section>
</template>

<script>
import { saveQnaCls, getQnaClsDetail } from "@/api/qna";

export default {
  data() {
    return {
      qnaCls: { crudType: "I" },
      classId: "",
    };
  },
  mounted() {
    if (this.$route.params.classId != null) {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.classId = this.$route.params.classId;
        const { data } = await getQnaClsDetail(this.classId);
        this.qnaCls = data.qnaCls;
        this.qnaCls.crudType = "U";
      } catch (err) {
        console.log(err);
      }
    },
    // 분류등록
    async saveQnaCls() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        console.log(this.qnaCls);
        const { data } = await saveQnaCls(this.qnaCls);
        if (data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.$router.push({ name: "mgmtQnaCls" });
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style></style>
